import { FC } from "react"
import { FilterValues, TResource } from "widgets/mobileIndex/lib/hooks/useMobilePlace"
import { HallBody, HallContainer, HallTitle } from "./style";
import { Table } from "../table";
import { Control } from "react-hook-form";

interface HallProps {
  name: string;
  items: TResource[];
  onTableClick: (item:TResource) => void;
  activeTables: TResource[];
  control: Control<FilterValues, any>;
}

export const Hall: FC<HallProps> = ({
  name,
  items,
  onTableClick,
  activeTables,
  control
}) => {

  return (
    <HallContainer>
      <HallTitle>{name}</HallTitle>
      <HallBody>
        {
          items.map((item, index) => {
            return (
              <Table 
                item={item} 
                key={index} 
                onClick={onTableClick}
                isActive={activeTables.findIndex(el=>el.id===item.id) >= 0}
                control={control}
              />
            )
          })
        }
      </HallBody>
    </HallContainer>
  )
}